import { OrderAdjustmentModel } from 'api-hooks/order-adjustment';
import React from 'react';

import { OrderAdjustmentFormType } from '../components/form-type';

export default function useGetDefaultValues(
  orderAdjustment?: OrderAdjustmentModel,
) {
  const defaultValues = React.useMemo<OrderAdjustmentFormType>(() => {
    return {
      purchaseRefId: orderAdjustment?.purchase.refId ?? '',
      purchaseId: orderAdjustment?.purchase?.id ?? '',
      amount: orderAdjustment?.amount ?? 0,
      description: orderAdjustment?.description ?? '',
      refId: orderAdjustment?.refId,
      number: orderAdjustment?.number,
      transactionAt: orderAdjustment?.transactionAt ?? new Date(),
      orderAdjustment,
      purchase: orderAdjustment?.purchase,
    };
  }, [orderAdjustment]);

  return defaultValues;
}
